import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { CustomLink } from 'ziphy-web-shared/basic/lib/buttons';
import styles from './SidebarMenuItem.module.scss';
const SidebarMenuItem = ({ autoTarget, onClick, className, children, params, icon, counter, }) => {
    return (_jsxs(CustomLink, Object.assign({ autoTarget: autoTarget, type: "nav", onClick: onClick, className: classNames(styles.item, className), params: params }, { children: [icon && _jsx("div", Object.assign({ className: styles.icon }, { children: icon })), _jsx("span", Object.assign({ className: styles.text }, { children: children })), counter > 0 && _jsx("span", Object.assign({ className: styles.counter }, { children: counter }))] })));
};
export default SidebarMenuItem;
